var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.3529C22 17.4717 19.4416 20 16.2857 20H6.28571C3.91878 20 2 18.1038 2 15.7647C2 13.4256 3.91878 11.5294 6.28571 11.5294C6.56983 11.5294 6.8475 11.5567 7.11616 11.6089C6.88706 10.9978 6.7619 10.3369 6.7619 9.64706C6.7619 6.52827 9.32028 4 12.4762 4C15.4159 4 17.8371 6.19371 18.1551 9.01498C20.393 9.78024 22 11.8811 22 14.3529ZM14 14.7829C14 14.4074 14.2182 14.0728 14.5171 13.8455C15.4142 13.1635 16 12.0387 16 10.7668C16 8.68645 14.433 7 12.5 7C10.567 7 9 8.68645 9 10.7668C9 12.0351 9.58248 13.1571 10.4752 13.8396C10.7776 14.0708 10.9966 14.412 10.9913 14.7925L10.9858 15.1907C10.9819 15.4696 11.2069 15.6977 11.4858 15.6977H13.5C13.7761 15.6977 14 15.4738 14 15.1977V14.7829ZM10.75 17.2326C10.75 17.6468 11.0858 17.9826 11.5 17.9826H13.5C13.9142 17.9826 14.25 17.6468 14.25 17.2326C14.25 16.8183 13.9142 16.4826 13.5 16.4826H11.5C11.0858 16.4826 10.75 16.8183 10.75 17.2326Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIdea);
export default __webpack_public_path__ + "static/media/cloud-idea.2f2cf270afa378a3ffa188abe2585af7.svg";
export { ForwardRef as ReactComponent };